import { useQuery, skipToken } from '@tanstack/react-query';
import { dataApiClient } from '../../infrastructure/dataApi/client';
import type { Link } from '../../types/domain';
import { useCurrentSimDataId } from '../SimViewer/useCurrentSimDataId';

type UseLinksData = {
  isLoading: boolean;
  links: Map<string, Link>;
};

const EMPTY_DATA = new Map<string, never>();

const useLinksData = (): UseLinksData => {
  const { currentSimDataId } = useCurrentSimDataId();

  const { data, isFetching } = useQuery({
    queryKey: ['links', currentSimDataId],
    queryFn: currentSimDataId
      ? async (): Promise<Map<string, Link>> => {
          return dataApiClient
            .getLinks(currentSimDataId)
            .then((links: Link[]): Map<string, Link> => {
              return new Map<string, Link>(
                links.map((link: Link): [string, Link] => {
                  return [link.way_id, link];
                })
              );
            });
        }
      : skipToken,
    meta: { dataType: 'essentials' },
  });

  return {
    isLoading: isFetching,
    links: data ?? EMPTY_DATA,
  };
};

export { useLinksData };
